(function(){
if(window.__wvMm){return}
window.__wvMm=1;
var mm=null,lastFocus=null,timer=null,held=false;
function get(){mm=document.getElementById('wvMm');if(mm&&mm.parentNode!==document.body){document.body.appendChild(mm)}return mm}
function show(id){
 if(!get()){return}
 var v=mm.querySelectorAll('.wv-mm-view');
 for(var i=0;i<v.length;i++){
  var on=v[i].getAttribute('data-wv-view')===id;
  v[i].classList.toggle('is-on',on);
  v[i].setAttribute('aria-hidden',on?'false':'true');
 }
 var sc=mm.querySelector('[data-wv-view="'+id+'"] .wv-mm-scroll');
 if(sc){sc.scrollTop=0}
 var f=sc;if(f){f.setAttribute('tabindex','-1')}
 if(f){setTimeout(function(){try{f.focus({preventScroll:true})}catch(e){}},280)}
}
function open(id,instant){
 if(!get()){return}
 clearTimeout(timer);
 lastFocus=document.activeElement;
 mm.hidden=false;
 document.documentElement.classList.add('wv-mm-lock');
 show(id||'root');
 if(instant){document.documentElement.classList.add('wv-mm-instant');mm.classList.add('is-open')}else{window.requestAnimationFrame(function(){window.requestAnimationFrame(function(){mm.classList.add('is-open')})})}
}
function close(force){
 if(held&&!force){return}
 if(!get()||mm.hidden){return}
 mm.classList.remove('is-open');
 document.documentElement.classList.remove('wv-mm-lock');
 timer=setTimeout(function(){mm.hidden=true;show('root')},300);
 if(lastFocus&&lastFocus.focus){try{lastFocus.focus({preventScroll:true})}catch(e){}}
}
function isOpen(){return get()&&!mm.hidden&&mm.classList.contains('is-open')}
document.addEventListener('click',function(e){
 var t=e.target;if(!t.closest){return}
 var tg=t.closest('.js-mobile-nav-toggle');
 if(tg&&get()){e.preventDefault();e.stopImmediatePropagation();open('root');return}
 if(!get()||!mm.contains(t)){return}
 var go=t.closest('[data-wv-go]');
 if(go){e.preventDefault();show(go.getAttribute('data-wv-go'));return}
 if(t.closest('[data-wv-back]')){e.preventDefault();show('root');return}
 if(t.closest('[data-wv-close]')){e.preventDefault();close(true);return}
},true);
document.addEventListener('keydown',function(e){
 if(e.key!=='Escape'||!isOpen()){return}
 var onRoot=mm.querySelector('[data-wv-view="root"]').classList.contains('is-on');
 if(onRoot){close()}else{show('root')}
});
window.addEventListener('pageshow',function(e){if(e.persisted&&get()){mm.hidden=true;mm.classList.remove('is-open');document.documentElement.classList.remove('wv-mm-lock');show('root')}});
function reset(){if(get()){mm.hidden=true;mm.classList.remove('is-open');document.documentElement.classList.remove('wv-mm-lock')}}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',reset)}else{reset()}
})();
